import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

const Header = ({ title }) => (
  <div className={styles.header}>
    <h2>{title}</h2>
  </div>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
